import ko from 'knockout'
import { IStarterImageViewModelParams, StarterImageViewModel } from './StarterImageViewModel'
import template from './starter.image.tpl.html'

if (!ko.components.isRegistered('starter-image')) {
  ko.components.register('starter-image', {
    viewModel: {
      createViewModel: (params: IStarterImageViewModelParams) => {
        const viewModel = new StarterImageViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
